/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TermsAppendixParam
 */
export interface TermsAppendixParam {
    /**
     * 
     * @type {string}
     * @memberof TermsAppendixParam
     */
    fileId: string;
    /**
     * 
     * @type {string}
     * @memberof TermsAppendixParam
     */
    fileName: string;
}

/**
 * Check if a given object implements the TermsAppendixParam interface.
 */
export function instanceOfTermsAppendixParam(value: object): value is TermsAppendixParam {
    if (!('fileId' in value) || value['fileId'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    return true;
}

export function TermsAppendixParamFromJSON(json: any): TermsAppendixParam {
    return TermsAppendixParamFromJSONTyped(json, false);
}

export function TermsAppendixParamFromJSONTyped(json: any, ignoreDiscriminator: boolean): TermsAppendixParam {
    if (json == null) {
        return json;
    }
    return {
        
        'fileId': json['fileId'],
        'fileName': json['fileName'],
    };
}

export function TermsAppendixParamToJSON(value?: TermsAppendixParam | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fileId': value['fileId'],
        'fileName': value['fileName'],
    };
}

